import React from 'react';
import cls from 'classnames';
import styles from './Button.module.scss';

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  primary?: boolean;
  fullWidth?: boolean;
  disabled?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
} & (
    | {
        small?: boolean;
      }
    | { xsmall?: boolean }
  );

export function Button({
  primary,
  fullWidth,
  onClick,
  children,
  className,
  disabled = false,
  ...rest
}: React.PropsWithChildren<ButtonProps>) {
  return (
    <button
      className={cls(
        styles.button,
        className,
        'small' in rest && [styles.small, 'label-default'],
        'xsmall' in rest && [styles.xsmall, 'label-small'],
        {
          [styles.primary]: primary,
          [styles.fullWidth]: fullWidth,
        },
      )}
      onClick={onClick}
      disabled={disabled}
      {...rest}
    >
      {children}
    </button>
  );
}
